import api from '../../..'

const tasks = {
    create: async (requestId, payload) => {
        if (payload.serviceTaskAdditionalDetails && payload.serviceTaskAdditionalDetails.any()) {
            payload.serviceTaskAdditionalDetails.forEach((detail, index) => {
                if (Array.isArray(detail.value) && detail.value.any()) {
                    detail.value = detail.value.map((item) => item.id).join(',')
                }
            })
        }

        var packet = FormData.fromObject({
            requestId: payload.request.id,
            taskTypeId: payload.taskType.id,
            additionalNotes: payload.additionalNotes,
            serviceTaskAttachments: payload.serviceTaskAttachments
                ? payload.serviceTaskAttachments.map((a) => a.file).nonEmpty()
                : [],
            serviceTaskAdditionalDetails: payload.serviceTaskAdditionalDetails
        })

        var response = await api.post(`/maarima/ServiceTask/`, packet, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })

        return response.data
    },
    update: async (payload) => {
        if (payload.serviceTaskAdditionalDetails && payload.serviceTaskAdditionalDetails.any()) {
            payload.serviceTaskAdditionalDetails.forEach((detail, index) => {
                if (Array.isArray(detail.value) && detail.value.any()) {
                    detail.value = detail.value.map((item) => item.id).join(',')
                }
            })
        }

        var packet = FormData.fromObject({
            requestId: payload.request.id,
            taskTypeId: payload.taskType.id,
            additionalNotes: payload.additionalNotes,
            serviceTaskAttachments: payload.serviceTaskAttachments
                ? payload.serviceTaskAttachments.map((a) => a.file).nonEmpty()
                : [],
            serviceTaskAdditionalDetails: payload.serviceTaskAdditionalDetails
        })

        var response = await api.put(`/maarima/ServiceTask/${payload.id}`, packet, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        return response.data
    },
    fetch: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/ServiceTask`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data
    },
    fetchInactive: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/ServiceTask/inactive`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data
    },
    fetchPendingApproval: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/ServiceTask/pendingApproval`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data
    },
    fetchActive: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/ServiceTask/active`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data
    },
    uploadIptaasAttachment: async ({ serviceTaskId, payload }) => {
        var formData = new FormData()
        formData.append('file', payload.file)

        var response = await api.put(
            `/maarima/ServiceTask/${serviceTaskId}/IptaasAttachment`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )

        return response.data
    },
    uploadAttachment: async ({ serviceTaskId, payload }) => {
        var formData = new FormData()
        formData.append('file', payload.file)

        var response = await api.put(`/maarima/ServiceTask/${serviceTaskId}/Attachment`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        return response.data
    },

    serviceTaskApproval: async ({ serviceTaskId, isApproved, denialReason }) => {
        var response = await api.put(`/maarima/ServiceTask/${serviceTaskId}/Approval`, {
            isApproved,
            denialReason
        })

        return response.data
    },
    sendApprovalRequest: async (serviceTaskId) => {
        var response = await api.post(
            `/maarima/ServiceTask/${serviceTaskId}/sendApprovalRequest`,
            {}
        )
        return response.data
    },
    cancel: async (serviceTaskId) => {
        var response = await api.put(`/maarima/ServiceTask/${serviceTaskId}/Cancel`, {})

        return response.data
    }
}
export default tasks
